import { Global } from "../../Global";


// 全局头像变量
const mockAvatar = 'https://yuanling-new.oss-cn-shanghai.aliyuncs.com/frontend-static/b0/b041e158ffd1eb3cbc961d8f285c1639e1e32dcce0cb9cdcd25c1effe2096f78.jpg';

// mock 的 CurrentUser 数据结构
const mockCurrentBuyer = {
  token: 'mocked-token-123',
  buyerProps: {
    id: '10002',
    name: '李四',
    nickname: '四哥',
    avatarUrl: mockAvatar,
    phone: '13800000002',
    balance: 999.99,
    companyName: '上海公司',
  },
  loginUrl: '',
};

const mockAnotherBuyer = {
  token: 'mocked-token-456',
  buyerProps: {
    id: '10003',
    name: '王五',
    avatarUrl: mockAvatar,
    phone: '18217023008',
    balance: 2999,
    nickname: '五哥',
  },
};
 
const mockBuyerByToken123 = {
  buyerId: mockCurrentBuyer.buyerProps.id,
  trueName: mockCurrentBuyer.buyerProps.name,
  nickname: mockCurrentBuyer.buyerProps.nickname,
  avatarUrl: mockCurrentBuyer.buyerProps.avatarUrl,
  phone: mockCurrentBuyer.buyerProps.phone,
  balance: mockCurrentBuyer.buyerProps.balance,
  token: mockCurrentBuyer.token,
  isCompany: false,
  company: '上海魔法向量网络有限公司',
  level: 4,
  levelDesc: '铂金',
}
const mockBuyerByToken456 = {
  buyerId: mockAnotherBuyer.buyerProps.id,
  trueName: mockAnotherBuyer.buyerProps.name,
  nickname: mockAnotherBuyer.buyerProps.nickname,
  avatarUrl: mockAnotherBuyer.buyerProps.avatarUrl,
  phone: mockAnotherBuyer.buyerProps.phone,
  balance: mockAnotherBuyer.buyerProps.balance,
  token: mockAnotherBuyer.token,
  company: '阿里巴巴',
  isCompany: true,
  level: 2,
  levelDesc: '白银',
}

Global.setMockData('getBuyerByToken', mockBuyerByToken123);
Global.setMockData('mocked-token-123', mockBuyerByToken123);
Global.setMockData('mocked-token-456', mockBuyerByToken456);
 
Global.setMockData('loginByPhone', mockBuyerByToken456);

Global.setMockData('getBuyerInfo', [
  {
    buyerId: '10001',
    trueName: '张三',
    nickname: '三哥',
    company: '上海公司',
    avatarUrl: mockAvatar,
    wechatNo: 'zhangsan123',
    tiktokNo: 'zhangsan_tiktok',
    isCompany: false,
    phone: '13800000001',
    gender: 'male',
    level: 1,
    levelDesc: '青铜',
    updateTime: new Date().toISOString()
  },
  {
    buyerId: '10002',
    trueName: '李四',
    nickname: '四哥',
    company: '上海魔法向量网络有限公司',
    avatarUrl: mockAvatar,
    wechatNo: 'lisi456',
    tiktokNo: 'lisi_tiktok',
    isCompany: true,
    phone: '13800000002',
    gender: 'female',
    level: 3,
    levelDesc: '黄金',
    updateTime: new Date().toISOString()
  },
  {
    buyerId: '10003',
    trueName: '王五',
    nickname: '五哥',
    company: '阿里巴巴',
    avatarUrl: mockAvatar,
    wechatNo: 'wangwu789',
    tiktokNo: 'wangwu_tiktok',
    isCompany: true,
    phone: '13800000003',
    gender: 'male',
    level: 2,
    levelDesc: '白银',
    updateTime: new Date().toISOString()
  }
]);